export const getInitialState = (): any => ({
  datasourceColumnsData: []
});
